module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/品质中心配图.965a6aed.png";